import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;

  ${({ theme: { spacing } }) => css`
    padding: ${spacing.level6} ${spacing.level6} 0;
    gap: ${spacing.level2};
  `}

  @media (max-width: 768px) {
    ${({ theme: { spacing } }) => css`
      padding: ${spacing.level5} ${spacing.level4} 0;
    `}
  }
`;

export const NameEditRow = styled.div`
  display: flex;
  align-items: center;

  ${({ theme: { spacing } }) => css`
    gap: ${spacing.level3};
  `}

  @media (max-width: 600px) {
    flex-wrap: wrap;
  }
`;

export const NameInput = styled.input`
  ${({ theme: { colors, font, spacing, borderRadius } }) => css`
    padding: ${spacing.level3} ${spacing.level4};
    border-radius: ${borderRadius.small};
    border: 1px solid ${colors.outline};
    background: transparent;
    color: ${colors.onSurface};
    font-size: ${font.bodyMedium.fontSize};
    font-family: ${font.bodyMedium.fontFamily};
    width: 200px;
    text-align: right;

    &:focus {
      outline: none;
      border-color: ${colors.primary};
    }

    &::placeholder {
      color: ${colors.onSurfaceVariant};
    }

    @media (max-width: 600px) {
      width: 100%;
      text-align: left;
    }
  `}
`;
